






















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import * as Components from '@/agiles/components';

@Component
export default class PageLayout extends Vue {
  @Prop() public item: Common.PageLayout;
  @Prop() public parent: Common.ReportLayout;
  @Prop() public editor: Components.IEditor;
  @Prop({default:true}) public enabled: boolean;

  regexRange = "^[a-zA-Z]{1,2}[1-9][0-9]{0,2}:[a-zA-Z]{1,2}[1-9][0-9]{0,2}$";
  regexRangeMsg = "無効なフォーマットです。『A1:ZZ999』書式で指定してください。";
}
